import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

function ChoiceFringe({ modelTop, modelValance, setModelFringe}) {
	const [activeIndex, setActiveIndex] = useState(null);

	const handleModelSelection = (item, index) => {
		if (activeIndex === index) {
			setActiveIndex(null);
			
			setModelFringe({});
			return;
		}
		
		setActiveIndex(index);
		setModelFringe(() => item);
	}

	useEffect(() => {
		setActiveIndex(null);// reset selected item on change modelValance
		setModelFringe({});
	}, [modelTop, modelValance]);

	if (!!!modelValance || !!!modelValance.fringe || !!!modelTop.valance ) {
		return null;
	}

	return (
		<div className="choices">
			<ul>
				{modelValance.fringe.list.map((item, index) => (
					<li key={index}>
						<a
							onClick={(e) => {
								e.preventDefault();
								handleModelSelection(item, index)
							}}
							className={classNames('preview decor-checkbox', { 'is-active': activeIndex === index })}
							href={item.model}
						>
							<picture className="preview__media">
								<img src={item.preview} alt={item.name} />
							</picture>

							<div className="preview__content">
								<h6>{item.name}</h6>
							</div>
						</a>
					</li>
				))}
			</ul>
		</div>
	);
}

export default ChoiceFringe;